// src/DoublePuzzle.js
import React, {useState} from 'react';

const shuffle = (word) => {
  return word.split('').sort(() => Math.random() - 0.5).join('');
};

const DoublePuzzle = ({word}) => {
  const [shuffledWord, setShuffledWord] = useState(shuffle(word));
  const [guess, setGuess] = useState('');
  const [message, setMessage] = useState('');

  const handleChange = (e) => {
    setGuess(e.target.value);
  };

  const handleSubmit = (e) => {
    e.preventDefault();
    if (guess.toLowerCase() === word.toLowerCase()) {
      setMessage('Correct! Well done!');
    } else {
      setMessage('Try again!');
    }
  };

  const handleReset = () => {
    setShuffledWord(shuffle(word));
    setGuess('');
    setMessage('');
  };

  return (
    <div style={{textAlign: 'center', marginTop: '50px'}}>
      <h1>Double Puzzle Game</h1>
      <p>Unscramble the letters to form a word or phrase:</p>
      <h2>{shuffledWord}</h2>
      <form onSubmit={handleSubmit}>
        <input
          type="text"
          value={guess}
          onChange={handleChange}
          style={{fontSize: '20px', padding: '10px', width: '300px'}}
        />
        <button type="submit" style={{marginLeft: '10px', fontSize: '20px'}}>
          Submit
        </button>
      </form>
      <p>{message}</p>
      <button onClick={handleReset} style={{marginTop: '20px', fontSize: '20px'}}>
        Reset
      </button>
    </div>
  );
};

export default DoublePuzzle;
